<template>
  <div id="comp-list-item" :class="{ 'item-select': isVisibleSelector }">
    <div v-if="isSwipeEnabled">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide>
          <div class="slide-wrapper">
            <div class="rank-container" :class="rankBtn">
              <span>{{ rank }}</span>
            </div>
            <div class="select-container">
              <label class="container">
                <input
                  :type="selectorType"
                  :name="selectorType == 'radio' ? 'member' : ''"
                  @click="$emit('itemSelected', userSeqId)"
                />
                <span class="checkmark"></span>
              </label>
            </div>

            <div class="profile-container" @click="getProfile(userSeqId)">
              <div class="profile-wrapper">
                <!-- 그룹 프로필 -->
                <comp-members v-if="itemType == 'group'" :members="members" />
                <comp-profile
                  v-else
                  :userInitial="userName"
                  :profileImage="profileImage"
                  :badgeBtn="leaderFlag"
                />
              </div>
            </div>

            <div class="name-container" @click="getMatchResult(userSeqId)">
              {{ fullName }}
            </div>
            <div class="chart-container" @click="getMatchResult(userSeqId)">
              <div class="circle-chart-container">
                <comp-chart-circle :data="matchingRate"></comp-chart-circle>
                <div class="rate-overlay">{{ matchingRate }}%</div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide style="width:100px">
          <div class="slide-wrapper">
            <div
              class="slide-container-btn"
              @click="deleteMatchUser(userSeqId)"
            >
              삭제
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <div v-else>
      <div class="slide-wrapper">
        <div class="rank-container" :class="rankBtn">
          <span>{{ rank }}</span>
        </div>
        <div class="select-container">
          <label class="container">
            <input
              :type="selectorType"
              :name="selectorType == 'radio' ? 'member' : ''"
              @click="$emit('itemSelected', userSeqId)"
            />
            <span class="checkmark"></span>
          </label>
        </div>

        <div class="profile-container" @click="getProfile(userSeqId)">
          <div class="profile-wrapper">
            <!-- 그룹 프로필 -->
            <comp-members v-if="itemType == 'group'" :members="members" />
            <comp-profile
              v-else
              :userInitial="userName"
              :profileImage="profileImage"
              :badgeBtn="leaderFlag"
              :isMe="userSeqId == this.$store.getters.getUserSeqId"
            />
          </div>
        </div>

        <div class="name-container" @click="getMatchResult(userSeqId)">
          {{ fullName }}
        </div>
        <div
          class="chart-container"
          v-if="matchingRate > 0"
          @click="getMatchResult(userSeqId)"
        >
          <div class="circle-chart-container">
            <comp-chart-circle :data="matchingRate"></comp-chart-circle>
            <div class="rate-overlay">
              {{ `${matchingRate}%` }}
            </div>
          </div>
        </div>
        <div
          v-else-if="
            matchingRate == 0 && userSeqId != this.$store.getters.getUserSeqId
          "
          class="name-container"
        >
          ?
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

import CompProfile from './CompProfile';
import CompMembers from './CompMembers';
import CompChartCircle from './CompChartCircle';
import RESPONSE from '../constants/response';

export default {
  name: 'comp-list-item',
  props: {
    matchingRate: Number,
    userName: String,
    fullName: String,
    userSeqId: Number,
    rankBtn: String,
    rank: Number,
    profileImage: String,
    members: Array,
    isSwipeEnabled: Boolean,
    itemType: String,
    isVisibleSelector: Boolean,
    selectorType: String,
    leaderFlag: String,
  },
  components: {
    swiper,
    swiperSlide,
    CompProfile,
    CompMembers,
    CompChartCircle,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    getProfile(id) {
      if (this.isVisibleSelector) {
        return;
      } else if (this.itemType === 'group') {
        this.$emit('groupItemClicked');
        return;
      }
      this.$emit('getProfile', id, this.fullName);
    },
    getMatchResult(id) {
      if (this.isVisibleSelector) {
        return;
      } else if (this.itemType === 'group') {
        this.$emit('groupItemClicked');
        return;
      }
      this.$emit('getMatchResult', id, this.fullName);
    },
    deleteMatchUser(matchUserSeqId) {
      if (this.isVisibleSelector) {
        return;
      } else if (this.itemType === 'group') {
        this.$emit('groupItemClicked');
        return;
      }
      this.$emit('wait');

      this.$store.dispatch('deleteMatchUser', matchUserSeqId).then((data) => {
        const status = data.status;
        if (status === RESPONSE.SUCCESS.CODE) {
          this.$emit('refreshList');
        }
      });
    },
  },
};
</script>

<style lang="scss" src="../scss/comp-list-item.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/CompListItem.vue